import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f01df8b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "_custom" }, "Custom", -1))

import { watch, ref } from 'vue'


export default {
  __name: 'SelectorWithCustomInput',
  props: {
  options: {
    type: Array,
    required: true
  },
  modelValue: {}
},
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props;





const selectionValue = ref(props.modelValue)
const customValue = ref('')

watch(selectionValue, (value) => {
  if (selectionValue.value !== '_custom') {
    emits('update:modelValue', value)
  }
})

watch(customValue, (value) => {
  emits('update:modelValue', customValue)
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectionValue).value = $event)),
      class: _normalizeClass((selectionValue.value === '_custom') ? 'custom' : '')
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.name), 9, _hoisted_1))
      }), 128)),
      _hoisted_2
    ], 2), [
      [_vModelSelect, selectionValue.value]
    ]),
    (selectionValue.value === '_custom')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          placeholder: "custom",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((customValue).value = $event))
        }, null, 512)), [
          [_vModelText, customValue.value]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

}